var Region = "Tỉnh/Thành phố";
var Community = "Phường/Xã";
var viLang = {
	"src.mobile.AddressList.AddressList.0": "Bạn không thể thêm mới địa chỉ trên nền tảng mua hàng này",
	"src.mobile.AddressList.AddressList.1": "Bạn không thể thêm mới địa chỉ trên nền tảng mua hàng này",
	Region: Region,
	Community: Community
};

export { Community, Region, viLang as default };
